import React, { useRef, useEffect } from "react";
import Mission from "./Mission"; // import the Mission component
import Vision from "./Vision";
import Objective from "./Objective";
import Footer from "../../Home/footer/Footer";
import Middlebar from "../../Home/middleBar/Middlebar";
import Topheader from "../../Home/topHeader/Topheader";
import "./AboutUs.css";
import NavMenu from "../../Home/navigationBar/NavMenu";

const Aboutus = () => {
  return (
    <div>
      <Topheader />
      <Middlebar />
      <NavMenu />

      <div class="about-container">
        <h1 class="about-heading">ABOUT E I M S</h1>
        <img
          class="about-image"
          src={process.env.PUBLIC_URL + "/about.png"}
          alt="Description of the image"
        />
      </div>

      <section class="welcome-section">
        <div class="wel-container">
          <div class="welcome-container">
            <h2 class="welcome-heading">Welcome to Emaan Institute</h2>
            <p class="welcome-paragraph">
            EMAAN INSTITUTE OF MANAGEMENT & SCIENCES (EIMS) has been established through a Legislative Act of the Sindh Assembly (Sindh Act No: XXXV of 2018) and is approved and recognized by the Higher Education Commission (HEC) as Degree Awarding Institute in 2019. 
Emaan Institute Of Management & Sciences has been established for creating leaders and developing the best professionals in every arena of life. It is our motto to impart the best quality education to the people of Pakistan.
            </p>
          </div>
        </div>
      </section>
      <section class="recognized-section">
        <div class="recognized-container">
          <div class="recognized-heading-container">
            <h2 class="recognized-heading">
              Chartered by Government of Sindh,<br></br> RECOGNIZED BY HEC
              (HIGHER EDUCATION COMMISSION)
            </h2>
          </div>
          <div class="recognized-images-container">
            <img
              src={process.env.PUBLIC_URL + "/chartered.png"}
              alt="Image 1"
              class="chartered"
            />
            <img
              src={process.env.PUBLIC_URL + "/hec.png"}
              alt="Image 2"
              class="hec"
            />
          </div>
        </div>
      </section>

      {/* Render the Mission component */}
      <Mission/>
      <Vision />
      <Objective />

      <Footer />
    </div>
  );
};

export default Aboutus;
